import React, { FC } from 'react';

import classNames from 'classnames';

import { EvSection, EvSpinner, EvTitle } from '@evinced-private/ui-common';

import {
	MOBILE_SDK_DASHBOARD_PAGE_SUMMARY_SECTION_ID,
	MOBILE_SDK_DASHBOARD_PAGE_SUMMARY_TITLE_ID
} from 'data-automation-ids/MobileSdkDashboardAutomationIds';
import { SummaryPane } from 'src/common/components/summary-pane/SummaryPane';
import { SummaryItem } from 'src/common/interfaces/SummaryItem';

import './MobileSdkTestsSummary.scss';

interface IMobileSdkTestsSummaryProps {
	data: SummaryItem[];
	isLoading: boolean;
	selectedPeriodLabel?: string;
}

const getUsageDataTooltipText = (selectedPeriodLabel: string): string =>
	`Usage within the ${selectedPeriodLabel.toLowerCase()} compared to the previous period (if applicable).`;

export const MobileSdkTestsSummary: FC<IMobileSdkTestsSummaryProps> = ({
	data,
	isLoading,
	selectedPeriodLabel = 'All Tests'
}) => {
	return (
		<EvSection
			ariaLabel="Last month usage"
			skipLinkId="usage-section"
			className={classNames('dashboard-section', 'mobile-sdk-tests-summary')}
			ariaLive="polite"
			dataAutomationId={MOBILE_SDK_DASHBOARD_PAGE_SUMMARY_SECTION_ID}
		>
			<EvTitle
				titleText="Summary"
				headingLevel={2}
				className="page-heading"
				dataAutomationId={MOBILE_SDK_DASHBOARD_PAGE_SUMMARY_TITLE_ID}
				// MoreInfoContent is a React Element that doesn't accept string,
				// eslint-disable-next-line react/jsx-no-useless-fragment
				MoreInfoContent={<>{getUsageDataTooltipText(selectedPeriodLabel)}</>}
			/>
			{isLoading ? (
				<EvSpinner />
			) : (
				<SummaryPane
					items={data}
					shouldHaveSkipLink={false}
					className="base-summary-pane"
					ariaLabel="Last month usage summary"
				/>
			)}
		</EvSection>
	);
};
